import { Outlet } from 'react-router-dom'
import { Sidebar } from '@/components/navigation/Sidebar'
import { SidebarMobile } from '@/components/navigation/SidebarMobile'
import { useSidebar } from '@/hooks/useSidebar'
import { cn } from '@/lib/utils'

export function DashboardLayout() {
  const { isCollapsed } = useSidebar()

  return (
    <div className="relative mx-auto max-w-screen-2xl">
      {/* Desktop Sidebar */}
      <Sidebar />

      {/* Mobile Sidebar */}
      <SidebarMobile />

      {/* Main Content */}
      <main
        className={cn(
          // Padding baseado no estado do sidebar
          isCollapsed ? 'lg:pl-[88px]' : 'lg:pl-[272px]',
          // Mobile sem padding
          'min-h-screen',
          // Transição suave
          'transform-gpu transition-all duration-300 ease-out will-change-[padding]',
          // Desktop styling
          'lg:bg-background lg:py-3 lg:pr-3',
        )}
      >
        <div className="bg-card p-4 sm:p-6 lg:rounded-lg min-h-[calc(100vh-1.5rem)]">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
